import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class PageNotFound extends Component {
  render() {
    return (
      <div>
        <h1>Page cannot be found</h1>
        <Link to="/">Home</Link>
      </div>
    );
  }
}
